// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  private eventDetails = {
    title: 'Wedding Ceremony',
    startDate: '20250528T050000Z',
    endDate: '20250528T080000Z',
    location: '[Wedding Venue]',
    details: 'Join us in celebrating our wedding!'
  };

  constructor() { }

  getGoogleCalendarLink(): string {
    return `https://www.google.com/calendar/render?action=TEMPLATE&text=${this.eventDetails.title}&dates=${this.eventDetails.startDate}/${this.eventDetails.endDate}&details=${this.eventDetails.details}&location=${this.eventDetails.location}`;
  }

  getICSFileLink(): string {
    return 'assets/wedding-invite.ics';
  }

  getOutlookCalendarLink(): string {
    return `https://outlook.live.com/owa/?rru=addevent&startdt=2025-05-28T05:00:00Z&enddt=2025-05-28T08:00:00Z&subject=${this.eventDetails.title}&location=${this.eventDetails.location}&body=${this.eventDetails.details}`;
  }

  detectDevice(): string {
    const userAgent = navigator.userAgent;
    if (/Android/i.test(userAgent)) {
      return 'android';
    } else if (/iPhone|iPad|Macintosh/i.test(userAgent)) {
      return 'apple';
    } else if (/Windows NT|Win64|WOW64|Outlook/i.test(userAgent)) {
      return 'desktop';
    }
    return 'desktop';
  }
}
